/**
 * Jira REST attachment URLs, as written into ticket comment bodies by the
 * member communication service. Both the `content` and `thumbnail` variants end
 * in the numeric attachment id, e.g.
 * https://sidecarhealth.atlassian.net/rest/api/3/attachment/content/237730
 */
const JIRA_ATTACHMENT_URL =
  /\/rest\/api\/\d+\/attachment\/(?:content|thumbnail)\/(\d+)/

/**
 * Pulls the attachment id out of a Jira REST attachment URL.
 *
 * These URLs require Jira authentication, so they are never usable directly by
 * a member. The id lets us request the file through our own authenticated
 * endpoints instead.
 *
 * @param {string} url The URL to inspect
 * @returns {string | null} The attachment id, or null if the URL is not a Jira
 *   attachment URL
 */
export const getJiraAttachmentId = (url?: string): string | null => {
  const [, attachmentId] = JIRA_ATTACHMENT_URL.exec(url || '') || []
  return attachmentId || null
}
